import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { PathwaySection } from './components/PathwaySection';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { AudienceSection } from './components/AudienceSection';
import { DifferenceSection } from './components/DifferenceSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { AuthorSection } from './components/AuthorSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-ink font-sans text-white" data-id="element-0" data-mp="3mkrefndynled">
      <MetaPixel data-id="element-1" data-mp="3rbrakqf99zft" />
      <Hero data-id="element-2" data-mp="3rdaq2et386gj" />
      <main data-id="element-3" data-mp="3rdkl4gszp3t3">
        <ProblemSection data-id="element-4" data-mp="3rd1a7k1rbfok" />
        <PathwaySection data-id="element-5" data-mp="5yk6vxnnffx" />
        <VolumesSection data-id="element-6" data-mp="6hpnd64cbd2" />
        <BonusesSection data-id="element-7" data-mp="4n5w26l2pak" />
        <BeforeAfterSection data-id="element-8" data-mp="82ld64660ci" />
        <AudienceSection data-id="element-9" data-mp="2zld0l5ad579f" />
        <DifferenceSection data-id="element-10" data-mp="2zm4y4lnitf2c" />
        <TestimonialsSection data-id="element-11" data-mp="2zmwif0bo3qdb" />
        <AuthorSection data-id="element-12" data-mp="33mov9p83gioh" />
        <OfferSection data-id="element-13" data-mp="33m5eibu6k0c1" />
        <GuaranteeSection data-id="element-14" data-mp="33ngee0ki8nxv" />
        <FaqSection data-id="element-15" data-mp="33oriy2lrxzq1" />
        <FinalCta data-id="element-16" data-mp="38lrqkhy9vaj9" />
      </main>
      <Footer data-id="element-17" data-mp="38li6fazwrxlh" />
      <FloatingCta data-id="element-18" data-mp="38l05i12awv78" />
      <PurchasePopup data-id="element-19" data-mp="38kglmet3bwqk" />
    </div>;
}